import Cookies from 'js-cookie';
import { AuthCookieName } from '../auth/auth-constant';

export const getHeaders = () => {
  if (typeof window !== 'undefined') {
    const cookieToken = Cookies.get(AuthCookieName);
    const storageToken = localStorage.getItem(AuthCookieName);
    const token = cookieToken ?? storageToken;
    return {
      authorization: token ? `Bearer ${token}` : '',
    };
  } else {
    return { authorization: '' };
  }
};
